import { gql } from '@apollo/client';

export default gql`
    query($offset: Int!, $admin: String){
        LanguageLimit(offset: $offset, admin: $admin) {
            IdIdioma
            Idioma
        }
    }
`;